import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  compose,
  setDisplayName,
  branch,
  renderNothing,
  withProps
} from "recompose";
import SelectRole from "../../components/SelectRole";
import DealerForm from "../../components/DealerForm";
import ContactSection from "../../components/ContactSection";
import WithFetchDealer from "../WithFetchDealer/index";
import { actions } from "../../modules/auth";

const mapDispatchToProps = {
  logout: actions.logout,
  setLogoutInterceptor: actions.setLogoutInterceptor
};
const mapStateToProps = state => ({
  user: state.auth.user,
  role: state.settings.role
});

const withState = connect(mapStateToProps);

const propTypes = {
  user: PropTypes.object.isRequired
};

const justStaff = branch(({ role }) => role !== "staff", renderNothing);
const justCustomer = branch(({ role }) => role !== "customer", renderNothing);

const DealerSettings = compose(
  setDisplayName("DealerSettings"),
  WithFetchDealer,
  withState,
  justStaff,
  withProps(({ currentDealer, updateDealer }) => ({
    initialValues: currentDealer,
    onSubmit: updateDealer
  }))
)(DealerForm);

const ContactsSettings = compose(
  setDisplayName("ContactSettings"),
  withState,
  justCustomer
)(ContactSection);

const Settings = props => {
  let settings;
  if (props.user) {
    settings = (
      <div className="content">
        <h3>Settings</h3>
        <hr />
        <SelectRole />
        <DealerSettings {...props} />
        <ContactsSettings {...props} />
      </div>
    );
  } else {
    settings = () => {
      const {
        logout,
        location,
        history: { replace }
      } = props;
      logout(location).then(next => {
        replace(`/${next}`);
      });
    };
  }

  return settings;
};

Settings.propTypes = propTypes;

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Settings);
